import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../components/InputField";
import SelectField from "../components/SelectField";
import Button from "../components/Button";
import Breadcrumbs from "../components/Breadcrumbs";
import api from "../api/api";
import { useAuth } from "../context/AuthContext";
import "./progressbar.css";
 
const steps = [
  {
    heading: "Shipment Details",
    validationSchema: Yup.object({
      natureOfGoods: Yup.string().required("Required"),
      hsnCode: Yup.string().required("Required"),
      portOrigin: Yup.string().required("Required"),
      portDestination: Yup.string().required("Required"),
      incoterm: Yup.string().required("Required"),
      modeOfTransport: Yup.string().required("Required"),
      containerType: Yup.string().required("Required"),
      totalWeightOrVolume: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      specialHandling: Yup.string().required("Required"),
      tradeAgreement: Yup.string().required("Required"),
    }),
    fields: [
      {
        name: "natureOfGoods",
        label: "What is the Nature of Goods being Imported/Exported?",
        type: "text",
        placeholder: "Enter the Nature of Goods",
      },
      {
        name: "hsnCode",
        label: "What is the HSN code for the Goods?",
        type: "text",
        placeholder: "Enter the HSN Code",
      },
      {
        name: "portOrigin",
        label: "What is the Port of Origin?",
        type: "text",
        placeholder: "Enter the Port of Origin",
      },
      {
        name: "portDestination",
        label: "What  is the Port of Destination?",
        type: "text",
        placeholder: "Enter the Port of Destination",
      },
      {
        name: "incoterm",
        label:
          "What is the INCOTERM under which the  shipment is being processed?",
        type: "select",
        options: [
          { value: "Port to Port", label: "Port to Port" },
          { value: "Door to Door", label: "Door to Door" },
          { value: "Door to Port", label: "Door to Port" },
          { value: "Port to Door", label: "Port to Door" },
          { value: "ICD to Port", label: "ICD to Port" },
          { value: "ICD to Door", label: "ICD to Door" },
         
        ],
      },
      {
        name: "modeOfTransport",
        label: "What is the mode of transport (Air,Sea,Rail,Road)?",
        type: "text",
        placeholder: "Enter the Mode of Transport",
      },
      {
        name: "containerType",
        label:
          "Is this a Full Container Load (FCL) or Less than Container Load  (LCL) shipment?",
        type: "text",
        placeholder: "Enter the Container type",
      },
      {
        name: "totalWeightOrVolume",
        label: "What is the Total Weight or Total Volume of the Cargo?",
        type: "text",
        placeholder: "Enter total weight or volume",
      },
      {
        name: "specialHandling",
        label:
          "Are there any special handling requirements (tempreature-controlled, hazardous, oversized, etc.)?",
        type: "text",
        placeholder: "Enter the handling requirements",
      },
      {
        name: "tradeAgreement",
        label:
          "Is this shipment covered under any special trade agreements (FTA, PTA, SAFTA, etc.)?",
        type: "text",
        placeholder: "Enter the Trade Agreement",
      },
    ],
  },
 
  {
    heading: "Customs Documentation Checklist",
 
    validationSchema: Yup.object({
      billEntryAndShippingBill: Yup.string().required("Required"),
      shippingBillFiled: Yup.string().required("Required"),
      generalManifest: Yup.string().required("Required"),
      invoicePackingList: Yup.string().required("Required"),
      packingListVerified: Yup.string().required("Required"),
      billOfLandingOrAirwayBill: Yup.string().required("Required"),
      dutyExemption: Yup.string().required("Required"),
      letterOfCredit: Yup.string().required("Required"),
      insuranceCertificate: Yup.string().required("Required"),
      regulatoryLicenses: Yup.string().required("Required"),
    }),
 
    fields: [
      {
        name: "billEntryAndShippingBill",
        label:
          "Have the Bill of Entry (BE) been filled?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "shippingBillFiled",
        label:
          "Have the Shipping Bill (SB) been filed?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "generalManifest",
        label:
          "Have the Import General Manifest or Export General Manifest been submitted?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "invoicePackingList",
        label:
          "Is the Commercial Invoice provided and verified?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "packingListVerified",
        label:
          "Is the Packing List verified?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "billOfLandingOrAirwayBill",
        label:
          "Is the Bill of Lading (BL)/ Airway Bill (AWB) available and correct?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "dutyExemption",
        label:
          "Are there any duty exemptions or benefits applicable (e.g., EPCG, MEIS, SEIS, Advance Authorization)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "letterOfCredit",
        label:
          "Have the Letter of Credit (LC) or Bank Documents been verified?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "insuranceCertificate",
        label: "Is an Insurance Certificate required for the shipment?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "regulatoryLicenses",
        label:
          "Are there any Regulatory Licenses or NOCs needed (DGFT, FSSAI, Plant Quarantine, etc.)?",
        type: "text",
        placeholder: "Enter Regulatory Licenses",
      },
    ],
  },
 
  {
    heading: "Customs Duty & Taxation",
 
    validationSchema: Yup.object({
      customDutyRates: Yup.string().required("Required"),
      shipmentEligibile: Yup.string().required("Required"),
      gstAndIgstRates: Yup.string().required("Required"),
      applicableCessAndSurcharge: Yup.string().required("Required"),
      warehouseOptions: Yup.string().required("Required"),
    }),
 
    fields: [
      {
        name: "customDutyRates",
        label:
          "What is the applicable customs duty rate based on the HSN code?",
        type: "text",
        placeholder: "Enter Customs Duty Rates",
      },
      {
        name: "shipmentEligibile",
        label: "Is the Shipment Eligible for Duty Drawback and refunds?",
        type: "text",
        placeholder: "Enter Eligibility Details",
      },
      {
        name: "gstAndIgstRates",
        label:
          "Has the GST and IGST applicability been checked for compliance?",
        type: "text",
        placeholder: "Enter GST and IGST",
      },
      {
        name: "applicableCessAndSurcharge",
        label: "Have the applicable cess and surcharges been calculated?",
        type: "text",
        placeholder: "Enter Cess and Surcharge Details",
      },
      {
        name: "warehouseOptions",
        label:
          "Is the Bonded Warehouse option being available to defer duty payments?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
 
  {
    heading: "Regulatory & Compliance Checks",
 
    validationSchema: Yup.object({
      bisCertification: Yup.string().required("Required"),
      clearanceFromFssai: Yup.string().required("Required"),
      plantQuarantineClearance: Yup.string().required("Required"),
      dgftRequirements: Yup.string().required("Required"),
      antiDumpingDuties: Yup.string().required("Required"),
      shipmentFallsUnderRestrictedCategory: Yup.string().required("Required"),
      letterOfUndertaking: Yup.string().required("Required"),
      coopCertificates: Yup.string().required("Required"),
    }),
 
    fields: [
      {
        name: "bisCertification",
        label:
          "Does the cargo require Bureau of Indian Standards (BIS) Certification?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "clearanceFromFssai",
        label:
          "Does the cargo require clearance from Food Safety and Standards Authority of India (FSSAI)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "plantQuarantineClearance",
        label:
          "Has a Plant Quarantine (PQ) clearance been obtained for agricultural goods?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "dgftRequirements",
        label:
          "Have the DGFT (Directorate General of Foreign Trade) requirements been met?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "antiDumpingDuties",
        label: "Are there any Anti-Dumping Duties (ADD) applicable?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "shipmentFallsUnderRestrictedCategory",
        label:
          "Does the shipment fall under Restricted or Prohibited Goods as per Indian Customs?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "letterOfUndertaking",
        label:
          "Have the Letter of Undertaking (LUT) or Bond requirements been fulfilled?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "coopCertificates",
        label:
          "Has the Country of Origin (CoO) Certificate been provided where necessary?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
 
  {
    heading: "Examination & Customs Clearance",
 
    validationSchema: Yup.object({
      shipmentSubjectToExamination: Yup.string().required("Required"),
      csfOrIcdAllocation: Yup.string().required("Required"),
      customOfficerAssigned: Yup.string().required("Required"),
      customsClearanceCertificate: Yup.string().required("Required"),
      goodClarifiedAsPerHSCode: Yup.string().required("Required"),
      valuationDone: Yup.string().required("Required"),
    }),
 
    fields: [
      {
        name: "shipmentSubjectToExamination",
        label:
          "Is the shipment subject to random examination or 100% inspection?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "csfOrIcdAllocation",
        label:
          "Has the Container Freight Station (CFS) or Inland Container Depot (ICD) allocation been made?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "customOfficerAssigned",
        label:
          "Has a customs officer been assigned for Physical Verification (PV)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "customsClearanceCertificate",
        label: "Is a Customs Clearance Certificate (CCC) required?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "goodClarifiedAsPerHSCode",
        label: "Have the goods been classified under the correct HS Code?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "valuationDone",
        label:
          "Have valuation checks been completed to prevent under/over-invoicing issues?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
 
  {
    heading: "Port & Terminal Handling",
 
    validationSchema: Yup.object({
      deliveryOrderIssued: Yup.string().required("Required"),
      cargoHandlingChargesPaid: Yup.string().required("Required"),
      demergeAndDetentionChargesPaid: Yup.string().required("Required"),
      stuffingAndDestuffingCompleted: Yup.string().required("Required"),
      ebillOrTransportPermitGranted: Yup.string().required("Required"),
      cargoDamageOrLossSurvey: Yup.string().required("Required"),
    }),
    fields: [
      {
        name: "deliveryOrderIssued",
        label: "Has the Delivery Order (DO) been issued by the shipping line?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "cargoHandlingChargesPaid",
        label: "Have the Cargo Handling Charges (CHC) been paid?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "demergeAndDetentionChargesPaid",
        label: "Have the Demurrage & Detention charges been checked?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "stuffingAndDestuffingCompleted",
        label: "Has the stuffing & de-stuffing process been completed?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "ebillOrTransportPermitGranted",
        label:
          "Has the necessary E-way Bill / Transport Permit been generated?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
 
      {
        name: "cargoDamageOrLossSurvey",
        label: "Has a cargo damage/loss survey been conducted (if required)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
 
  {
    heading: "Post-Clearance Procedures",
    validationSchema: Yup.object({
      dutyPaymentConfirmed: Yup.string().required("Required"),
      cdrAndEdiConfirmation: Yup.string().required("Required"),
      esealVarificationCompleted: Yup.string().required("Required"),
      shipmentTrackingAndFinalDelivery: Yup.string().required("Required"),
      eodcFilled: Yup.string().required("Required"),
    }),
    fields: [
      {
        name: "dutyPaymentConfirmed",
        label: "Has the Duty Payment (Bill of Entry Duty) been confirmed?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "cdrAndEdiConfirmation",
        label:
          "Have the necessary  Customs Duty Receipt (CDR) & EDI confirmations been received?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "esealVarificationCompleted",
        label:
          "Has the Self-sealing & RFID E-Seal verification been completed for  factory-stuffed containers?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "eodcFilled",
        label:
          "Has the Export Obligation Discharge Certificate(EODC) been filled (if applicable)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "shipmentTrackingAndFinalDelivery",
        label:
          "Has  the Shipment Tracking & Final Delivery Acknowledgment been completed?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
  {
    heading: "Freight Assessment",
    validationSchema: Yup.object({
      psiConducted: Yup.string().required("Required"),
      goodVerifiedAndCorrectLabelling: Yup.string().required("Required"),
      sealingAndRfidEsealVerification: Yup.string().required("Required"),
      shipmentSubject: Yup.string().required("Required"),
      weightAndMeasurementChecked: Yup.string().required("Required"),
      cargoDamageSurvey: Yup.string().required("Required"),
      csfIcdhandlingChargesPaid: Yup.string().required("Required"),
    }),
    fields: [
      {
        name: "psiConducted",
        label: "Has a Pre-Shipment Inspection (PSI) been conducted?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "goodVerifiedAndCorrectLabelling",
        label:
          "Have the goods been verified for correct labeling and packaging as per customs  norms?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "sealingAndRfidEsealVerification",
        label:
          "Has a container sealing and RFID e-seal verification been done?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "shipmentSubject",
        label:
          "Is the shipment subject to random  examination or 100% customs  inspection?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "weightAndMeasurementChecked",
        label:
          "Have weighment and measurement checks been conducted to match declared values?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "cargoDamageSurvey",
        label: "Has the  Cargo damage survey been completed  (if applicable)?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
      {
        name: "csfIcdhandlingChargesPaid",
        label:
          "Are the Container Freight Station  (CFS) and inland Container Depot (ICD) handling charges  clear?",
        type: "select",
        options: [
          { value: "Yes", label: "Yes" },
          { value: "No", label: "No" },
        ],
      },
    ],
  },
];
 
  // Helper function to convert Y/N or Yes/No to Yes/No
  const convertFromYN = (value) => {
    if (value === "Y" || value === "Yes") return "Yes";
    if (value === "N" || value === "No") return "No";
    return "";
  };

  const getInitialValues = (existingAudit = null) => {
    // If we have existing audit data, use it
    if (existingAudit) {
      return {
        // Map database column names to form field names
        natureOfGoods: existingAudit.nature_of_goods || "",
        hsnCode: existingAudit.hsn_code || "",
        portOrigin: existingAudit.port_of_origin || "",
        portDestination: existingAudit.port_of_destination || "",
        incoterm: existingAudit.incoterm || "",
        modeOfTransport: existingAudit.mode_of_transport || "",
        containerType: existingAudit.shipment_type || "",
        totalWeightOrVolume: existingAudit.total_weight_or_volume || "",
        specialHandling: existingAudit.special_handling_requirements || "",
        tradeAgreement: existingAudit.covered_under_trade_agreements || "",

        billEntryAndShippingBill: convertFromYN(existingAudit.bill_of_entry_filed),
        shippingBillFiled: convertFromYN(existingAudit.shipping_bill_filed),
        generalManifest: convertFromYN(existingAudit.igm_or_egm_submitted),
        invoicePackingList: convertFromYN(existingAudit.commercial_invoice_verified),
        packingListVerified: convertFromYN(existingAudit.packing_list_verified),
        billOfLandingOrAirwayBill: convertFromYN(existingAudit.bl_or_awb_available),
        dutyExemption: convertFromYN(existingAudit.duty_exemptions_applicable),
        letterOfCredit: convertFromYN(existingAudit.lc_or_bank_docs_verified),
        insuranceCertificate: convertFromYN(existingAudit.insurance_certificate_required),
        regulatoryLicenses: existingAudit.regulatory_licenses_required || "",

        customDutyRates: existingAudit.customs_duty_rate || "",
        shipmentEligibile: existingAudit.eligible_for_duty_drawback || "",
        gstAndIgstRates: existingAudit.gst_igst_checked || "",
        applicableCessAndSurcharge: existingAudit.cess_surcharge_calculated || "",
        warehouseOptions: convertFromYN(existingAudit.bonded_warehouse_availed),

        bisCertification: convertFromYN(existingAudit.bis_certification_required),
        clearanceFromFssai: convertFromYN(existingAudit.fssai_clearance_required),
        plantQuarantineClearance: convertFromYN(existingAudit.pq_clearance_obtained),
        dgftRequirements: convertFromYN(existingAudit.dgft_requirements_met),
        antiDumpingDuties: convertFromYN(existingAudit.anti_dumping_duty_applicable),
        shipmentFallsUnderRestrictedCategory: convertFromYN(existingAudit.restricted_or_prohibited_goods),
        letterOfUndertaking: convertFromYN(existingAudit.lut_or_bond_fulfilled),
        coopCertificates: convertFromYN(existingAudit.certificate_of_origin_provided),

        shipmentSubjectToExamination: convertFromYN(existingAudit.shipment_subject_to_examination),
        csfOrIcdAllocation: convertFromYN(existingAudit.cfs_or_icd_allocated),
        customOfficerAssigned: convertFromYN(existingAudit.customs_officer_assigned),
        customsClearanceCertificate: convertFromYN(existingAudit.customs_clearance_certificate_required),
        goodClarifiedAsPerHSCode: convertFromYN(existingAudit.correct_hs_code_classified),
        valuationDone: convertFromYN(existingAudit.valuation_check_done),

        deliveryOrderIssued: convertFromYN(existingAudit.delivery_order_issued),
        cargoHandlingChargesPaid: convertFromYN(existingAudit.cargo_handling_charges_paid),
        demergeAndDetentionChargesPaid: convertFromYN(existingAudit.demurrage_detention_checked),
        stuffingAndDestuffingCompleted: convertFromYN(existingAudit.stuffing_destuffing_completed),
        ebillOrTransportPermitGranted: convertFromYN(existingAudit.eway_bill_generated),
        cargoDamageOrLossSurvey: convertFromYN(existingAudit.cargo_damage_survey_conducted),

        dutyPaymentConfirmed: convertFromYN(existingAudit.duty_payment_confirmed),
        cdrAndEdiConfirmation: convertFromYN(existingAudit.customs_duty_receipts_received),
        esealVarificationCompleted: convertFromYN(existingAudit.rfi_seal_verification_done),
        eodcFilled: convertFromYN(existingAudit.eodc_filed),
        shipmentTrackingAndFinalDelivery: convertFromYN(existingAudit.shipment_tracking_acknowledged),

        psiConducted: convertFromYN(existingAudit.pre_shipment_inspection_done),
        goodVerifiedAndCorrectLabelling: convertFromYN(existingAudit.labeling_packaging_verified),
        sealingAndRfidEsealVerification: convertFromYN(existingAudit.container_rfid_sealed),
        shipmentSubject: convertFromYN(existingAudit.random_or_full_inspection_done),
        weightAndMeasurementChecked: convertFromYN(existingAudit.weighment_measurement_verified),
        cargoDamageSurvey: convertFromYN(existingAudit.cargo_damage_survey_completed),
        csfIcdhandlingChargesPaid: convertFromYN(existingAudit.cfs_icd_charges_cleared),
      };
    }

  // Default values: "" for all fields (empty initially)
  return steps.reduce((acc, step) => {
    step.fields.forEach((field) => {
      acc[field.name] = "";
    });
    return acc;
  }, {});
};
 
const AuditDetails = () => {
  const navigate = useNavigate();
  const { id: enq_id } = useParams(); // Get enquiry ID from URL (route param is :id)
  const { user } = useAuth();
  const [step, setStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [existingAudit, setExistingAudit] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [currentFormValues, setCurrentFormValues] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [initialValues, setInitialValues] = useState(() =>
    steps.reduce((acc, step) => {
      step.fields.forEach((field) => (acc[field.name] = ""));
      return acc;
    }, {})
  );

  // Fetch existing audit data and handle resume logic
  useEffect(() => {
    const fetchExistingAudit = async () => {
      try {
        setLoading(true);

        // First check localStorage for in-progress work
        const savedData = localStorage.getItem(`audit_${enq_id}`);
        let localData = null;
        if (savedData) {
          try {
            localData = JSON.parse(savedData);
          } catch (error) {
            console.error('Error parsing localStorage data:', error);
            localStorage.removeItem(`audit_${enq_id}`); // Clear corrupted data
          }
        }

        // Then check database for saved progress
        const response = await api.get(`/audit-details/${enq_id}`);
        const dbData = response.data;

        if (localData) {
          // Prioritize localStorage data (user's current session)
          // Merge localStorage data with default values to ensure all fields exist
          const defaultValues = getInitialValues();
          // Filter out empty values from localStorage, keep only user-entered values
          const filteredLocalData = Object.keys(localData.formData).reduce((acc, key) => {
            const value = localData.formData[key];
            // Only keep values that are not empty
            if (value !== "") {
              acc[key] = value;
            }
            return acc;
          }, {});
          const mergedValues = { ...defaultValues, ...filteredLocalData };
          setInitialValues(mergedValues);
          setCompletedSteps(localData.completedSteps || []);
          setStep(Number(localData.currentStep) || 0);
        } else if (dbData) {
          // Use database data if no localStorage
          setExistingAudit(dbData);
          setInitialValues(getInitialValues(dbData));

          // Set completed steps based on database current_step
          const completed = [];
          if (dbData.current_step && dbData.current_step > 0) {
            for (let i = 0; i < dbData.current_step; i++) {
              completed.push(i);
            }
          }
          setCompletedSteps(completed);

          // Set current step
          if (completed.length === steps.length) {
            // Completed audit, show the last step
            setStep(steps.length - 1);
          } else if (dbData.current_step && dbData.current_step <= steps.length) {
            setStep(Number(dbData.current_step));
          }
        } else {
          // No existing data, start fresh
          setInitialValues(getInitialValues());
          setCompletedSteps([]);
          setStep(0);
        }
      } catch (error) {
        console.error('Error fetching existing audit:', error);
        setErrorMessage("Failed to load existing audit data. Starting fresh.");
        // Start fresh if there's an error
        setInitialValues(getInitialValues());
        setCompletedSteps([]);
        setStep(0);
      } finally {
        setLoading(false);
      }
    };

    if (enq_id) {
      fetchExistingAudit();
    }
  }, [enq_id]);

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);
 
  const handleSubmit = async (values, actions, isFinalSubmit = false) => {
    const currentStepSchema = steps[step].validationSchema || Yup.object({});

    try {
      await currentStepSchema.validate(values, { abortEarly: false });
      actions.setErrors({});
    } catch (err) {
      if (err.inner) {
        const formErrors = {};
        err.inner.forEach((e) => {
          formErrors[e.path] = e.message;
        });
        actions.setErrors(formErrors);
      }
      return;
    }

    // Mark current step as completed
    const newCompletedSteps = [...completedSteps, step];
    setCompletedSteps(newCompletedSteps);

    if (isFinalSubmit) {
      // Submit button clicked - merge current values with existing data and save to database
      setSubmitting(true);
      try {
        // Merge current form values with existing audit data to ensure all fields are saved
        const mergedValues = { ...initialValues, ...values };
        await saveToDatabase(mergedValues, newCompletedSteps, Number(step) + 1); // Save current step + 1 as next step
        setShowSuccessModal(true);
        setErrorMessage(""); // Clear any previous errors
        setTimeout(() => {
          navigate('/cha-services-requests');
        }, 2000); // Navigate after showing success modal for 2 seconds
      } catch (error) {
        console.error('Submission failed:', error);
        setErrorMessage("Failed to submit audit details. Please try again.");
      } finally {
        setSubmitting(false);
      }
    } else {
      // Next button clicked - merge current values with existing data and save to localStorage
      const mergedFormData = { ...initialValues, ...values };
      // Filter out empty values when saving to localStorage
      const filteredFormData = Object.keys(mergedFormData).reduce((acc, key) => {
        const value = mergedFormData[key];
        // Only save non-empty values
        if (value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});
      const saveData = {
        formData: filteredFormData,
        completedSteps: newCompletedSteps,
        currentStep: step + 1,
        timestamp: new Date().toISOString()
      };
      localStorage.setItem(`audit_${enq_id}`, JSON.stringify(saveData));
      // Update initialValues to include the merged data
      setInitialValues(mergedFormData);
      nextStep();
    }
  };

  const handleConfirmSubmit = () => {
    setShowConfirmModal(false);
    if (currentFormValues) {
      // Merge current form values with existing data to ensure all fields are saved
      const mergedValues = { ...initialValues, ...currentFormValues };
      handleSubmit(mergedValues, { setErrors: () => {} }, true);
    }
  };

  // Helper function to convert Yes/No to Y/N, allow null for unfilled
  const convertToYN = (value) => {
    if (value === "Yes") return "Y";
    if (value === "No") return "N";
    // For empty values, return null to keep them unfilled
    return null;
  };

  const saveToDatabase = async (values, completedSteps, nextStepNumber) => {
    // Prepare data for database
    const auditData = {
      enq_id: enq_id,
      cha_user_id: user?.user_id,

      // Validate required fields
      ...(enq_id && { enq_id }),
      ...(user?.user_id && { cha_user_id: user.user_id }),

      // Map form field names to database column names
      nature_of_goods: values.natureOfGoods,
      hsn_code: values.hsnCode,
      port_of_origin: values.portOrigin,
      port_of_destination: values.portDestination,
      incoterm: values.incoterm,
      mode_of_transport: values.modeOfTransport,
      shipment_type: values.containerType,
      total_weight_or_volume: values.totalWeightOrVolume ? parseFloat(values.totalWeightOrVolume) : null,
      special_handling_requirements: values.specialHandling,
      covered_under_trade_agreements: values.tradeAgreement,

      bill_of_entry_filed: convertToYN(values.billEntryAndShippingBill),
      shipping_bill_filed: convertToYN(values.shippingBillFiled),
      igm_or_egm_submitted: convertToYN(values.generalManifest),
      commercial_invoice_verified: convertToYN(values.invoicePackingList),
      packing_list_verified: convertToYN(values.packingListVerified),
      bl_or_awb_available: convertToYN(values.billOfLandingOrAirwayBill),
      duty_exemptions_applicable: convertToYN(values.dutyExemption),
      lc_or_bank_docs_verified: convertToYN(values.letterOfCredit),
      insurance_certificate_required: convertToYN(values.insuranceCertificate),
      regulatory_licenses_required: values.regulatoryLicenses,

      customs_duty_rate: values.customDutyRates,
      eligible_for_duty_drawback: values.shipmentEligibile,
      gst_igst_checked: values.gstAndIgstRates,
      cess_surcharge_calculated: values.applicableCessAndSurcharge,
      bonded_warehouse_availed: convertToYN(values.warehouseOptions),

      bis_certification_required: convertToYN(values.bisCertification),
      fssai_clearance_required: convertToYN(values.clearanceFromFssai),
      pq_clearance_obtained: convertToYN(values.plantQuarantineClearance),
      dgft_requirements_met: convertToYN(values.dgftRequirements),
      anti_dumping_duty_applicable: convertToYN(values.antiDumpingDuties),
      restricted_or_prohibited_goods: convertToYN(values.shipmentFallsUnderRestrictedCategory),
      lut_or_bond_fulfilled: convertToYN(values.letterOfUndertaking),
      certificate_of_origin_provided: convertToYN(values.coopCertificates),

      shipment_subject_to_examination: convertToYN(values.shipmentSubjectToExamination),
      cfs_or_icd_allocated: convertToYN(values.csfOrIcdAllocation),
      customs_officer_assigned: convertToYN(values.customOfficerAssigned),
      customs_clearance_certificate_required: convertToYN(values.customsClearanceCertificate),
      correct_hs_code_classified: convertToYN(values.goodClarifiedAsPerHSCode),
      valuation_check_done: convertToYN(values.valuationDone),

      delivery_order_issued: convertToYN(values.deliveryOrderIssued),
      cargo_handling_charges_paid: convertToYN(values.cargoHandlingChargesPaid),
      demurrage_detention_checked: convertToYN(values.demergeAndDetentionChargesPaid),
      stuffing_destuffing_completed: convertToYN(values.stuffingAndDestuffingCompleted),
      eway_bill_generated: convertToYN(values.ebillOrTransportPermitGranted),
      cargo_damage_survey_conducted: convertToYN(values.cargoDamageOrLossSurvey),

      duty_payment_confirmed: convertToYN(values.dutyPaymentConfirmed),
      customs_duty_receipts_received: convertToYN(values.cdrAndEdiConfirmation),
      rfi_seal_verification_done: convertToYN(values.esealVarificationCompleted),
      eodc_filed: convertToYN(values.eodcFilled),
      shipment_tracking_acknowledged: convertToYN(values.shipmentTrackingAndFinalDelivery),

      pre_shipment_inspection_done: convertToYN(values.psiConducted),
      labeling_packaging_verified: convertToYN(values.goodVerifiedAndCorrectLabelling),
      container_rfid_sealed: convertToYN(values.sealingAndRfidEsealVerification),
      random_or_full_inspection_done: convertToYN(values.shipmentSubject),
      weighment_measurement_verified: convertToYN(values.weightAndMeasurementChecked),
      cargo_damage_survey_completed: convertToYN(values.cargoDamageSurvey),
      cfs_icd_charges_cleared: convertToYN(values.csfIcdhandlingChargesPaid),

      // Workflow metadata
      current_step: parseInt(nextStepNumber, 10),
      completed_steps: JSON.stringify(completedSteps),
      status: nextStepNumber > steps.length ? 'completed' : 'in_progress'
    };

    try {
      // Save to database
      const response = await api.post('/audit-details/save', auditData);
      console.log('Audit details saved to database:', response.data);

      // Clear localStorage after successful database save
      localStorage.removeItem(`audit_${enq_id}`);

    } catch (error) {
      console.error('Error saving audit details to database:', error);
      throw error; // Re-throw to handle in calling function
    }
  };
 
  return (
    <>
      <Breadcrumbs />
      <h5 className="fw-bold mb-3">{steps[step].heading}</h5>
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="step-progress-wrapper d-flex justify-content-between mb-4">
        {steps.map((s, i) => (
          <div
            key={i}
            className={`step-progress-item ${
              i === step ? "active" : i < step ? "completed" : ""
            }`}
          >
            <div className="circle">{i + 1}</div>
            {/* <span className="label">{s.heading}</span> */}
 
            {i < steps.length - 1 && <div className="line" />}
          </div>
        ))}
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={steps[step].validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          setFieldValue,
          setFieldTouched,
          errors,
          touched,
        }) => (
          <Form>
            <div className="row">
              {steps[step].fields.map((field) => (
                <div className="col-md-6 mb-3" key={field.name}>
                  {field.type === "select" ? (
                    <SelectField
                      label={field.label}
                      name={field.name}
                      options={field.options}
                      error={touched[field.name] && errors[field.name]}
                      disabled={completedSteps.includes(step)}
                    />
                  ) : (
                    <InputField
                      label={field.label}
                      name={field.name}
                      value={values[field.name]}
                      onChange={handleChange}
                      placeholder={field.placeholder}
                      error={touched[field.name] && errors[field.name]}
                      disabled={completedSteps.includes(step)}
                    />
                  )}
                </div>
              ))}
            </div>
 
            <div className="row justify-content-end mt-4 ">
              {step > 0 && (
                <div className="col-4 col-md-2">
                  <Button
                    variant="secondary"
                    text="Previous"
                    onClick={prevStep}
                    btncls="w-100"
                  />
                </div>
              )}
              {!completedSteps.includes(step) && (
                <div className="col-4 col-md-2">
                  <Button
                    type="button"
                    variant="success"
                    text={submitting ? "Submitting..." : "Submit"}
                    btncls="w-100"
                    disabled={submitting}
                    onClick={() => {
                      // Store current form values and show confirmation modal
                      setCurrentFormValues(values);
                      setShowConfirmModal(true);
                    }}
                  />
                </div>
              )}
              {step < steps.length - 1 && (
                <div className="col-4 col-md-2">
                  <Button
                    type="submit"
                    variant="secondary"
                    text="Next"
                    btncls="w-100"
                  />
                </div>
              )}
              
            </div>
          </Form>
        )}
      </Formik>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Submission</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to submit the audit details? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <Button
                  variant="secondary"
                  text="Cancel"
                  onClick={() => setShowConfirmModal(false)}
                />
                <Button
                  variant="success"
                  text="Confirm Submit"
                  onClick={handleConfirmSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowSuccessModal(false);
                    navigate('/cha-services-requests');
                  }}
                ></button>
              </div>
              <div className="modal-body text-center">
                <p>Audit details submitted successfully!</p>
                <p>You will be redirected to the CHA Services page shortly.</p>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  variant="primary"
                  text="OK"
                  onClick={() => {
                    setShowSuccessModal(false);
                    navigate('/cha-services-requests');
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal backdrop */}
      {(showConfirmModal || showSuccessModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};
 
export default AuditDetails;